import { Panel, Flex, Container, Avatar, Typography, Grid, CellList, CellHeader, CellSimple, CellAction, Counter, CellInput, Switch, Button, IconButton } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const ProfileExample = {
    title: 'Profile',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview({ props }){
        return (
                <Panel
                    mode="secondary"
                    style={{ paddingTop: 16, paddingBottom: 16 }}
                >
                    <Flex
                        direction="column"
                        align="center"
                        gap={24}
                    >
                        <Container fullWidth>
                            <Flex
                                direction="column"
                                align="center"
                                gap={16}
                            >
                                <Avatar.Container
                                    size={80}
                                    onlineStatus
                                >
                                    <Avatar.Image
                                        fallback="ME"
                                        src="https://sun9-77.userapi.com/s/v1/ig2/4iImaZbByvdNqUJMhtOQivmXejSSWPXHVV6hqT-R4C-pLcKIfYM-Fug7ABB4r2C1M5SAFnR4UwVVd-qfhEJbq0Kh.jpg?quality=95&crop=0,0,853,853&as=32x32,48x48,72x72,108x108,160x160,240x240,360x360,480x480,540x540,640x640,720x720&ava=1&u=b1xqTXlJEHG1HUVKhZobYbEnwGYuh4BvLBYPL2lCZqI&cs=200x200"
                                    />
                                </Avatar.Container>

                                <Flex
                                    direction="column"
                                    align="center"
                                >
                                    <Typography.Headline variant="large-strong">Vadim Tregubenko</Typography.Headline>
                                    <Typography.Body variant="small">1 подписчик</Typography.Body>
                                </Flex>

                                <Grid
                                    cols={4}
                                    gap={8}
                                    style={{ width: '100%' }}
                                >
                                    <Flex
                                        align="center"
                                        direction="column"
                                        gap={4}
                                    >
                                        <IconButton
                                            aria-label="Уведомления"
                                            onClick={() => {}}
                                            variant="secondary"
                                        >
                                            <PlaceholderIcon />
                                        </IconButton>
                                        <Typography.Label variant="small">Уведомл.</Typography.Label>
                                    </Flex>

                                    <Flex
                                        align="center"
                                        direction="column"
                                        gap={4}
                                    >
                                        <IconButton
                                            aria-label="Поиск"
                                            onClick={() => {}}
                                            variant="secondary"
                                        >
                                            <PlaceholderIcon />
                                        </IconButton>
                                        <Typography.Label variant="small">Поиск</Typography.Label>
                                    </Flex>

                                    <Flex
                                        align="center"
                                        direction="column"
                                        gap={4}
                                    >
                                        <IconButton
                                            aria-label="Аудио"
                                            onClick={() => {}}
                                            variant="secondary"
                                        >
                                            <PlaceholderIcon />
                                        </IconButton>
                                        <Typography.Label variant="small">Аудио</Typography.Label>
                                    </Flex>

                                    <Flex
                                        align="center"
                                        direction="column"
                                        gap={4}
                                    >
                                        <IconButton
                                            aria-label="Ещё"
                                            onClick={() => {}}
                                            variant="secondary"
                                        >
                                            <PlaceholderIcon />
                                        </IconButton>
                                        <Typography.Label variant="small">Ещё</Typography.Label>
                                    </Flex>
                                </Grid>
                            </Flex>
                        </Container>

                        <Flex
                            direction="column"
                            gap={16}
                        >
                            <CellList
                                mode="island"
                                header={<CellHeader>О себе</CellHeader>}
                            >
                                <CellSimple
                                    height="compact"
                                    title="Frontend engineer 👨‍💻"
                                />
                            </CellList>

                            <CellList
                                mode="island"
                                header={<CellHeader>Телефон</CellHeader>}
                            >
                                <CellAction
                                    height="compact"
                                    onClick={() => {}}
                                >
                                    +8 888 888-88-88
                                </CellAction>
                            </CellList>

                            <CellList mode="island">
                                <CellSimple
                                    showChevron
                                    before={<PlaceholderIcon />}
                                    onClick={() => {}}
                                    title="Вложения"
                                    after={(
                                        <Counter
                                            value={1245}
                                            rounded
                                        />
                                    )}
                                    subtitle="Фото, видео, файлы и ссылки"
                                />
                            </CellList>
                        </Flex>

                        <CellList
                            mode="island"
                            header={<CellHeader>Настройки</CellHeader>}
                        >
                            <CellInput
                                before="Статус"
                                placeholder="Укажите статус"
                            />

                            <CellInput
                                before="Страна"
                                placeholder="Укажите страну"
                            />

                            <CellInput
                                before="Город"
                                placeholder="Укажите город"
                            />

                            <CellSimple
                                as="label"
                                title="Закрытый профиль"
                                after={(
                                    <Switch defaultChecked={false} />
                                )}
                            />
                        </CellList>
                        <Container style={{ width: '100%' }}>
                            <Flex gap={8}>
                                <Button
                                    size="large"
                                    variant="secondary"
                                    stretched
                                >
                                    Выйти
                                </Button>

                                <IconButton
                                    size="large"
                                    variant="secondary"
                                >
                                    <PlaceholderIcon />
                                </IconButton>
                            </Flex>
                        </Container>
                    </Flex>
                </Panel>
        )
    },

    getCode(){
        return `<Panel
  className={styles.page}
  mode="secondary"
>
  <Flex
    direction="column"
    gap={24}
  >
    <Container className={styles.header}>
      <Flex
        direction="column"
        align="center"
        gap={16}
      >
        <Avatar.Container
          size={80}
          onlineStatus
        >
          <Avatar.Image
            fallback="ME"
            src="..."
          />
        </Avatar.Container>

        <Flex
          className={styles.details}
          direction="column"
          align="center"
        >
          <Typography.Headline variant="large-strong">Vadim Tregubenko</Typography.Headline>
          <Typography.Body variant="small" className={styles.subsLabel}>1 подписчик</Typography.Body>
        </Flex>

        <Grid
          className={styles.actions}
          cols={4}
          gap={8}
        >
          <Flex direction="column" align="center" gap={4}>
            <IconButton
              aria-label="Уведомления"
              onClick={() => {}}
              variant="secondary"
            >
              <Icon24Placeholder />
            </IconButton>
            <Typography.Label variant="small">Уведомл.</Typography.Label>
          </Flex>
          ...
        </Grid>
      </Flex>
    </Container>

    <Flex
      direction="column"
      gap={16}
      className={styles.body}
    >
      <CellList
        mode="island"
        header={<CellHeader>О себе</CellHeader>}
      >
        <CellSimple
          height="compact"
          title="Frontend engineer 👨‍💻"
        />
      </CellList>
      ...
    </Flex>

    <CellList
      mode="island"
      header={<CellHeader>Настройки</CellHeader>}
    >
      <CellInput before="Статус" placeholder="Укажите статус" />
      ...
    </CellList>

    <Container className={styles.actions}>
      <Flex gap={8}>
        <Button
          size="large"
          variant="secondary"
          stretched
        >
          Выйти
        </Button>
        <IconButton
          size="large"
          variant="secondary"
        >
          <Icon24Placeholder />
        </IconButton>
      </Flex>
    </Container>
  </Flex>
</Panel>`
    }

}